// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel-item {
  position: relative;
  overflow: hidden;
}

.carousel-image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.carousel-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  /* Fit the image down the container */
  border-radius: 20px;
  /* Rounded corners */
  /*box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.5);  Shadow effect */
  transition: transform 0.3s ease;
  /* Add transition effect */
}

.carousel-caption h5 {
  color: #fff;
  margin: 0;
  font-size: 16px;
}

.carousel-caption-small h5 {
  color: #fff;
  margin: 0;
  font-size: 10px;
}

.attraction-description {
  color: #fff;
  margin: 10px 0 0;
  /* Margin for description */
  font-size: 12px;
  line-height: 14px;
}

.carousel-caption {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Background color for caption */
  padding: 40px;
  box-sizing: border-box;
  opacity: 0;
  /* Initially hide the caption */
  border-radius: 20px;
  transition: opacity 0.3s ease;
  /* Add transition effect */
}

.carousel-caption-small {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  /* Background color for caption */
  padding: 5px;
  box-sizing: border-box;
  /* Initially hide the caption */
  border-radius: 20px;
  transition: opacity 0.3s ease;
  /* Add transition effect */
}

.carousel-image-container:hover .carousel-caption {
  opacity: 1;
  /* Show the caption on hover */
}

.icon-cards_small_size {
  position: relative;
  width: 45vw;
  height: 35vw;
  max-width: 450px;
  max-height: 300px;
  margin: 0;
  color: white;
  perspective: 2000px;
  transform-origin: center;
}
.icon-cards_small_size__content {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center;
  transform-style: preserve-3d;
  transform: translateZ(-30vw) rotateY(0);
  animation: carousel 15s infinite cubic-bezier(0.77, 0, 0.175, 1) forwards;
}
.icon-cards_small_size__content.step-animation {
  animation: carousel 15s infinite steps(1) forwards;
}
.icon-cards_small_size__item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 45vw;
  height: 35vw;
  max-width: 450px;
  max-height: 300px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transform-origin: center;
}
.icon-cards_small_size__item:nth-child(1) {
  transform: rotateY(0) translateZ(45vw);
}
.icon-cards_small_size__item:nth-child(2) {
  transform: rotateY(72deg) translateZ(45vw);
}
.icon-cards_small_size__item:nth-child(3) {
  transform: rotateY(144deg) translateZ(45vw);
}
.icon-cards_small_size__item:nth-child(4) {
  transform: rotateY(216deg) translateZ(45vw);
}
.icon-cards_small_size__item:nth-child(5) {
  transform: rotateY(288deg) translateZ(45vw);
}
.icon-cards_small_size:hover .icon-cards__content {
  animation-play-state: paused;
}

.icon-cards {
  position: relative;
  width: 70vw;
  height: 50vw;
  max-width: 600px;
  max-height: 450px;
  margin: 0;
  color: white;
  perspective: 2500px;
  transform-origin: center;
}
.icon-cards__content {
  position: absolute;
  width: 100%;
  height: 100%;
  transform-origin: center;
  transform-style: preserve-3d;
  transform: translateZ(-30vw) rotateY(0);
  animation: carousel 15s infinite cubic-bezier(0.77, 0, 0.175, 1) forwards;
}
.icon-cards__content.step-animation {
  animation: carousel 15s infinite steps(1) forwards;
}
.icon-cards__item {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 70vw;
  height: 50vw;
  max-width: 600px;
  max-height: 450px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  transform-origin: center;
}
.icon-cards__item:nth-child(1) {
  transform: rotateY(0) translateZ(40vw);
}
.icon-cards__item:nth-child(2) {
  transform: rotateY(72deg) translateZ(40vw);
}
.icon-cards__item:nth-child(3) {
  transform: rotateY(144deg) translateZ(40vw);
}
.icon-cards__item:nth-child(4) {
  transform: rotateY(216deg) translateZ(40vw);
}
.icon-cards__item:nth-child(5) {
  transform: rotateY(288deg) translateZ(40vw);
}
.icon-cards:hover .icon-cards__content {
  animation-play-state: paused;
}

@keyframes carousel {
  0%, 10% {
    transform: translateZ(-35vw) rotateY(0);
  }
  17%, 27% {
    transform: translateZ(-35vw) rotateY(-72deg);
  }
  34%, 44% {
    transform: translateZ(-35vw) rotateY(-144deg);
  }
  51%, 61% {
    transform: translateZ(-35vw) rotateY(-216deg);
  }
  68%, 78% {
    transform: translateZ(-35vw) rotateY(-288deg);
  }
  85%, 100% {
    transform: translateZ(-35vw) rotateY(-360deg);
  }
}
.title_offer_after {
  background: #d2b356;
  display: block;
  width: 30px;
  height: 5px;
  margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/attractions-page/attractions-page.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,oBAAA;EACA,+DAAA;EACA,+BAAA;EACA,0BAAA;AACF;;AAEA;EACE,WAAA;EACA,SAAA;EACA,eAAA;AACF;;AACA;EACE,WAAA;EACA,SAAA;EACA,eAAA;AAEF;;AACA;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,iBAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oCAAA;EACA,iCAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,+BAAA;EACA,mBAAA;EACA,6BAAA;EACA,0BAAA;AAEF;;AACA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,oCAAA;EACA,iCAAA;EACA,YAAA;EACA,sBAAA;EACA,+BAAA;EACA,mBAAA;EACA,6BAAA;EACA,0BAAA;AAEF;;AACA;EACE,UAAA;EACA,8BAAA;AAEF;;AAIA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AADF;AAKE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,uCAAA;EACA,yEAAA;AAHJ;AAKI;EACE,kDAAA;AAHN;AAOE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,wBAAA;AALJ;AAOI;EACE,sCAAA;AALN;AAQI;EACE,0CAAA;AANN;AASI;EACE,2CAAA;AAPN;AAUI;EACE,2CAAA;AARN;AAWI;EACE,2CAAA;AATN;AAaE;EACE,4BAAA;AAXJ;;AAeA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,wBAAA;AAZF;AAgBE;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,4BAAA;EACA,uCAAA;EACA,yEAAA;AAdJ;AAgBI;EACE,kDAAA;AAdN;AAoBE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,yCAAA;EACA,kBAAA;EACA,wBAAA;AAlBJ;AAoBI;EACE,sCAAA;AAlBN;AAqBI;EACE,0CAAA;AAnBN;AAsBI;EACE,2CAAA;AApBN;AAuBI;EACE,2CAAA;AArBN;AAwBI;EACE,2CAAA;AAtBN;AA0BE;EACE,4BAAA;AAxBJ;;AA8BA;EAEE;IAEE,uCAAA;EA7BF;EAgCA;IAEE,4CAAA;EA/BF;EAkCA;IAEE,6CAAA;EAjCF;EAoCA;IAEE,6CAAA;EAnCF;EAsCA;IAEE,6CAAA;EArCF;EAwCA;IAEE,6CAAA;EAvCF;AACF;AA2CA;EACE,mBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;AAzCF","sourcesContent":[".carousel-item {\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.carousel-image-container {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.carousel-image-container img {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  /* Fit the image down the container */\r\n  border-radius: 20px;\r\n  /* Rounded corners */\r\n  /*box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.5);  Shadow effect */\r\n  transition: transform 0.3s ease;\r\n  /* Add transition effect */\r\n}\r\n\r\n.carousel-caption h5 {\r\n  color: #fff;\r\n  margin: 0;\r\n  font-size: 16px;\r\n}\r\n.carousel-caption-small h5 {\r\n  color: #fff;\r\n  margin: 0;\r\n  font-size: 10px;\r\n}\r\n\r\n.attraction-description {\r\n  color: #fff;\r\n  margin: 10px 0 0;\r\n  /* Margin for description */\r\n  font-size: 12px;\r\n  line-height: 14px;\r\n}\r\n\r\n.carousel-caption {\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  /* Background color for caption */\r\n  padding: 40px;\r\n  box-sizing: border-box;\r\n  opacity: 0;\r\n  /* Initially hide the caption */\r\n  border-radius: 20px;\r\n  transition: opacity 0.3s ease;\r\n  /* Add transition effect */\r\n}\r\n\r\n.carousel-caption-small{\r\n  position: absolute;\r\n  bottom: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  background-color: rgba(0, 0, 0, 0.7);\r\n  /* Background color for caption */\r\n  padding: 5px;\r\n  box-sizing: border-box;\r\n  /* Initially hide the caption */\r\n  border-radius: 20px;\r\n  transition: opacity 0.3s ease;\r\n  /* Add transition effect */\r\n}\r\n\r\n.carousel-image-container:hover .carousel-caption {\r\n  opacity: 1;\r\n  /* Show the caption on hover */\r\n}\r\n\r\n\r\n// Cards Carousel\r\n// ----------------------------------------------\r\n.icon-cards_small_size {\r\n  position: relative;\r\n  width: 45vw;\r\n  height: 35vw;\r\n  max-width: 450px;\r\n  max-height: 300px;\r\n  margin: 0;\r\n  color: white;\r\n  perspective: 2000px;\r\n  transform-origin: center;\r\n\r\n  // This is the element that rotates with the animation\r\n\r\n  &__content {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    transform-origin: center;\r\n    transform-style: preserve-3d;\r\n    transform: translateZ(-30vw) rotateY(0);\r\n    animation: carousel 15s infinite cubic-bezier(0.77, 0, 0.175, 1) forwards;\r\n\r\n    &.step-animation {\r\n      animation: carousel 15s infinite steps(1) forwards;\r\n    }\r\n  }\r\n\r\n  &__item {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: 45vw;\r\n    height: 35vw;\r\n    max-width: 450px;\r\n    max-height: 300px;\r\n    box-shadow: 0 5px 20px rgba(0, 0, 0, .1);\r\n    border-radius: 6px;\r\n    transform-origin: center;\r\n\r\n    &:nth-child(1) {\r\n      transform: rotateY(0) translateZ(45vw);\r\n    }\r\n\r\n    &:nth-child(2) {\r\n      transform: rotateY(72deg) translateZ(45vw);\r\n    }\r\n\r\n    &:nth-child(3) {\r\n      transform: rotateY(144deg) translateZ(45vw);\r\n    }\r\n\r\n    &:nth-child(4) {\r\n      transform: rotateY(216deg) translateZ(45vw);\r\n    }\r\n\r\n    &:nth-child(5) {\r\n      transform: rotateY(288deg) translateZ(45vw);\r\n    }\r\n  }\r\n\r\n  &:hover .icon-cards__content {\r\n    animation-play-state: paused;\r\n  }\r\n}\r\n\r\n.icon-cards {\r\n  position: relative;\r\n  width: 70vw;\r\n  height: 50vw;\r\n  max-width: 600px;\r\n  max-height: 450px;\r\n  margin: 0;\r\n  color: white;\r\n  perspective: 2500px;\r\n  transform-origin: center;\r\n\r\n  // This is the element that rotates with the animation\r\n\r\n  &__content {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    transform-origin: center;\r\n    transform-style: preserve-3d;\r\n    transform: translateZ(-30vw) rotateY(0);\r\n    animation: carousel 15s infinite cubic-bezier(0.77, 0, 0.175, 1) forwards;\r\n\r\n    &.step-animation {\r\n      animation: carousel 15s infinite steps(1) forwards;\r\n    }\r\n  }\r\n\r\n  // Individual cards\r\n\r\n  &__item {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: 70vw;\r\n    height: 50vw;\r\n    max-width: 600px;\r\n    max-height: 450px;\r\n    box-shadow: 0 5px 20px rgba(0, 0, 0, .1);\r\n    border-radius: 6px;\r\n    transform-origin: center;\r\n\r\n    &:nth-child(1) {\r\n      transform: rotateY(0) translateZ(40vw);\r\n    }\r\n\r\n    &:nth-child(2) {\r\n      transform: rotateY(72deg) translateZ(40vw);\r\n    }\r\n\r\n    &:nth-child(3) {\r\n      transform: rotateY(144deg) translateZ(40vw);\r\n    }\r\n\r\n    &:nth-child(4) {\r\n      transform: rotateY(216deg) translateZ(40vw);\r\n    }\r\n\r\n    &:nth-child(5) {\r\n      transform: rotateY(288deg) translateZ(40vw);\r\n    }\r\n  }\r\n\r\n  &:hover .icon-cards__content {\r\n    animation-play-state: paused;\r\n  }\r\n}\r\n\r\n// Carousel animation\r\n\r\n@keyframes carousel {\r\n\r\n  0%,\r\n  10% {\r\n    transform: translateZ(-35vw) rotateY(0);\r\n  }\r\n\r\n  17%,\r\n  27% {\r\n    transform: translateZ(-35vw) rotateY(-72deg);\r\n  }\r\n\r\n  34%,\r\n  44% {\r\n    transform: translateZ(-35vw) rotateY(-144deg);\r\n  }\r\n\r\n  51%,\r\n  61% {\r\n    transform: translateZ(-35vw) rotateY(-216deg);\r\n  }\r\n\r\n  68%,\r\n  78% {\r\n    transform: translateZ(-35vw) rotateY(-288deg);\r\n  }\r\n\r\n  85%,\r\n  100% {\r\n    transform: translateZ(-35vw) rotateY(-360deg);\r\n  }\r\n}\r\n\r\n\r\n.title_offer_after {\r\n  background: #d2b356;\r\n  display: block;\r\n  width: 30px;\r\n  height: 5px;\r\n  margin-top: 10px;\r\n} "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
